import { render, staticRenderFns } from "./PayrollConceptList.vue?vue&type=template&id=3dbcc59c"
import script from "./PayrollConceptList.vue?vue&type=script&lang=js"
export * from "./PayrollConceptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports